export default __webpack_public_path__ + "static/media/JobSix3.ef79902b.jpg";